<template lang="pug">

  v-btn( :icon='!fab' @click="$refs.inputUpload.click()" :fixed='fab' :bottom='fab' :right='fab' :large='fab' :fab='fab' color='primary' )
    v-icon( v-if='!subiendo_imagen' small ) fa-camera
    v-progress-circular(
      v-if='subiendo_imagen'
      :value="carga"
      color="primary"
    ) {{ carga }}
    input( v-show="false" ref="inputUpload" type="file" @change='inputImage' accept='image/*' )
</template>
<script>
import {storage} from '@/FirebaseConfig'
import { mapActions } from 'vuex'
import {timeStampString} from '@/Helper'
export default {
  data: ()=>({
    value: '',
    imageFile: '',
    subiendo_imagen: false,
    carga: 0,
    imagen: ''
    
  }),
  methods: {
   
    ...mapActions({
      agregar: 'Imagenes/agregar'
    }),
    inputImage(event){
      let image = this.imageFile = event.target.files[0]
      let _this = this
      _this.subiendo_imagen = true
      let uploadTask = storage.ref(`/landing_page/${timeStampString()}`).put(image)
      uploadTask.on('state_changed', 
        snapshot =>{
          _this.carga = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        }, 
        error => {
          console.log(error)
        },
        () => {
          console.log()
          uploadTask.snapshot.ref.getDownloadURL().then( downloadURL => {
            _this.agregar({vínculo: downloadURL, nombre: uploadTask.snapshot.ref.name})
             
            _this.subiendo_imagen = false
          })
        }
      )
    }
  },
  props: {
    fab: Boolean
  }
}
</script>